import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { MORTGAGE_MINI_CALCULATOR_MF_NAME } from '../../constants/microfrontends';
import { useApplicationContext } from '../../utils/applicationContext';
import { LayoutBlock } from '../../components/LayoutBlock';
import { useSelector } from 'react-redux';
import { mortgageSeoPageUrlSelector } from '../../selectors/seoPages';
import { getUserRole } from '../../selectors/user/getUserRole';

export const MortgageMiniCalculatorWidget = () => {
  const { config } = useApplicationContext();
  const userRole = useSelector(getUserRole);
  const url = useSelector(mortgageSeoPageUrlSelector);
  const manifest = config.get<IMicrofrontendManifest>(`microfrontendManifests.${MORTGAGE_MINI_CALCULATOR_MF_NAME}`);
  const mortgageMiniCalculatorEnabled = config.get<boolean>('Newbuilding.MortgageMiniCalculator.Enabled');

  const isRealtor = userRole === 'specialist';

  if (!manifest || !mortgageMiniCalculatorEnabled || isRealtor) {
    return null;
  }

  return (
    <LayoutBlock data-testid="MortgageMiniCalculatorWidget">
      <Microfrontend
        name={manifest.microfrontendName}
        image={manifest.imageVersion}
        runtime={manifest.runtimeName}
        parameters={{
          defaultFormState: { newbuildingSeoLinkUrl: url },
        }}
        instance={manifest.instanceId}
      />
    </LayoutBlock>
  );
};
